module.exports = __webpack_public_path__ + "images/turbozaim-6ba64e74.png";